import React from "react";
import NameInput from "components/WPReactTable/components/NameInput";
import { Container, GroupName, Title } from "../../KanbanBoard/KanbanColumn";

function NewGroup({ setAddGroup, onSubmit, projectId, id }) {
  const refNameInput = React.useRef(null);

  React.useEffect(() => {
    refNameInput.current.focus();
  }, []);

  function _handleKeyPress(e) {
    if (e.which === 13 && !e.shiftKey) {
      e.preventDefault();
      _handleBlur(e);
    }
  }

  function _handleBlur(e) {
    if (e.target.value?.trim() && e.target.value.trim() !== "") {
      onSubmit && onSubmit(e.target.value.trim());
    } else {
      setAddGroup(false);
    }
    refNameInput.current.onChange("");
  }

  return (
    <Container id={id}>
      <Title>
        <GroupName canUpdateProject>
          <NameInput
            ref={refNameInput}
            width="100%"
            maxWidth="calc(100% - 15px)"
            defaultValue=""
            edit
            onKeyPress={_handleKeyPress}
            onBlur={_handleBlur}
            canEdit={true}
            className="kanban-name-group new-group"
            placeholder="Nhóm việc"
          />
        </GroupName>
      </Title>
    </Container>
  );
}

export default NewGroup;
